import * as React from "react";
const Twitter = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m21.422 21-7.498-10.928.013.01 6.76-7.832h-2.259l-5.507 6.375L8.558 2.25H2.634l7 10.203-.002-.001L2.25 21h2.259l6.122-7.093L15.497 21zM7.663 3.955l10.52 15.34h-1.79L5.863 3.956z"
            fill={props.color || "#8E8E8E"}
        />
    </svg>
);
export default Twitter;
